import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
import Grid from '@material-ui/core/Grid'
import ScrollableAnchor, { configureAnchors } from 'react-scrollable-anchor'

import { SlidingMedias, Markdown } from '.'
import { Heading3 } from '../styleguide'

import { NAVIGATION_HEIGHT } from '../layouts/Navigation'
import { HEADER_HEIGHT } from '../layouts/Header'

import DataTable from './DataTable'
import {
  SUMMARY_BAR_HEIGHT,
  SUMMARY_BAR_BORDER_WIDTH
} from '../components/SummaryBar'

configureAnchors({
  offset: -(
    NAVIGATION_HEIGHT +
    HEADER_HEIGHT +
    SUMMARY_BAR_HEIGHT -
    SUMMARY_BAR_BORDER_WIDTH
  ),
  scrollDuration: 800
})

const styles = {
  containerStyle: {
    paddingTop: 20,
    paddingBottom: 40,
    borderBottom: '1px solid #d6d8db',
    maxWidth: 1200,
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  noBorderStyle: {
    border: 'none'
  },
  headerContainerStyle: {
    marginBottom: 20
  },
  headlineStyle: {
    marginBottom: 10
  }
}

const ComponentSection = ({
  anchorId,
  headline,
  description,
  medias,
  table,
  isLastSection,
  classes: { containerStyle, noBorderStyle, headlineStyle }
}) => (
  <ScrollableAnchor id={anchorId}>
    <Grid
      container
      spacing={0}
      className={classNames(
        containerStyle,
        isLastSection && noBorderStyle,
        'component-section-container'
      )}
    >
      <Grid item xs lg={10}>
        <Heading3 className={headlineStyle}>{headline}</Heading3>
        <Markdown source={description} />
        {medias.length > 0 && <SlidingMedias medias={medias} />}
        {table && <DataTable data={table} />}
      </Grid>
    </Grid>
  </ScrollableAnchor>
)

export default withStyles(styles)(ComponentSection)



// WEBPACK FOOTER //
// ./src/components/ComponentSection.js